// extracted by mini-css-extract-plugin
export var program = "styles_program__Mr+0h";